import { useWatch } from "react-hook-form";
import { DropdownInput } from "../DropdownInput";
import { SwitchInput } from "../SwitchInput";

const TRAVEL_DISTANCE_OPTIONS = [
  { value: "0_50", label: "0-50" },
  { value: "51_200", label: "51-200" },
  { value: "200_plus", label: "200+" },
  { value: "nationwide_longhaul", label: "Nationwide / Longhaul" },
];

const DISQUALIFIER_QUESTIONS = [
  {
    id: "corgi-passenger-operations",
    name: "step3.corgiPassengerOperations",
    label: "Does the insured carry passengers?",
  },
  {
    id: "corgi-freight-forwarder",
    name: "step3.corgiFreightForwarder",
    label: "Is the insured a freight forwarder?",
  },
  {
    id: "corgi-transit-mixer",
    name: "step3.corgiTransitMixerOperations",
    label: "Does the insured operate transit mixers?",
  },
  {
    id: "corgi-delivery-courier",
    name: "step3.corgiDeliveryCourierOperations",
    label: "Does the insured perform food delivery, last-mile delivery, app-based delivery, or courier operations?",
  },
  {
    id: "corgi-armored-vehicles",
    name: "step3.corgiArmoredVehicles",
    label: "Does the insured operate armored vehicles?",
  },
  {
    id: "corgi-local-radius",
    name: "step3.corgiMostRunsUnder100Miles",
    label: "Are most of the insured's runs under 100 miles?",
  },
];

export function CorgiOperationsQuestions({ control }) {
  const carriers = useWatch({ control, name: "step3.carrier" }) || [];
  const wasAutoRemoved = useWatch({
    control,
    name: "step3.corgiAutoRemoved",
  });
  if (!carriers.includes("Corgi Trucking") && !wasAutoRemoved) return null;

  return (
    <div className="rounded-lg border p-4 space-y-4">
      <h3 className="text-lg font-semibold">Corgi Trucking</h3>
      <DropdownInput
        control={control}
        label="Travel distance?"
        dropdownLabel="Select Travel Distance"
        stepName="step3.corgiTravelDistance"
        stepId="step3"
        itemList={TRAVEL_DISTANCE_OPTIONS}
      />
      {wasAutoRemoved ? (
        <p className="rounded-md bg-amber-50 p-3 text-sm text-amber-900">
          Corgi Trucking is temporarily ineligible. Change the disqualifying answer back to No to restore it automatically.
        </p>
      ) : (
        <p className="text-sm text-slate-600">
          A Yes answer to any question below makes Corgi Trucking unavailable. Other selected carriers can continue.
        </p>
      )}
      {DISQUALIFIER_QUESTIONS.map((question) => (
        <SwitchInput
          key={question.id}
          control={control}
          id={question.id}
          stepName={question.name}
          stepId="step3"
          label={question.label}
        />
      ))}
    </div>
  );
}
